import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CourseAssignmentCompletionDocument } from './@types';

export function invalidateUserCourseAssignments(
   assignee_userid: number,
   documents: CourseAssignmentCompletionDocument[],
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('patch', `/course_assignments/User/invalidateAll/${assignee_userid}`, {
      ...common,
      body: {
         documents,
      },
   });
}

type InvalidateUserCourseAssignmentsErrorCode =
   | 'course_assignments.invalidate_user.user_not_found'
   | 'course_assignments.invalidate_user.insufficient_privileges';

invalidateUserCourseAssignments.errorMessages =
   createErrorMessageTypeGuard<InvalidateUserCourseAssignmentsErrorCode>();
